import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import FilterListIcon from "material-ui-icons/FilterList";

const styles = theme => ({
  root: {
    flexShrink: 0
  },
  toggleButton: {
    height: 36
  }
});

const OvToggleFilterPanel = props => {
  const { classes, filterPanelVisible, onVisibilityChange } = props;

  const handleToggle = () => {
    onVisibilityChange(!filterPanelVisible);
  };

  return (
    <div className={classes.root}>
      <IconButton
        className={classes.toggleButton}
        onClick={handleToggle}
        color="primary"
      >
        <FilterListIcon />
      </IconButton>
    </div>
  );
};

OvToggleFilterPanel.propTypes = {
  filterPanelVisible: PropTypes.bool,
  onVisibilityChange: PropTypes.func.isRequired
};

OvToggleFilterPanel.defaultProps = {
  filterPanelVisible: false
};

export { OvToggleFilterPanel };

export default withStyles(styles, { name: "OvToggleFilterPanel" })(
  OvToggleFilterPanel
);



// WEBPACK FOOTER //
// ./src/OvToggleFilterPanel.js